import subscriptions from '../../../../design3/asset-build/js/custom/subscriptions';

export default function lmlmForm() {
	subscriptions({
		userInfo: true,
		subscriptionChoices: true,
		legalAgreement: true,
		bodySelector: '.LmlmBody',
	});
}
